import { DOMNodeProps } from "@/types";

export default function LargeArrowRight(props: DOMNodeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="16"
      viewBox="0 0 39 16"
      fill="none"
      {...props}
    >
      <path
        d="M38.7071 8.70711C39.0976 8.31658 39.0976 7.68342 38.7071 7.29289L32.3431 0.928932C31.9526 0.538408 31.3195 0.538408 30.9289 0.928932C30.5384 1.31946 30.5384 1.95262 30.9289 2.34315L36.5858 8L30.9289 13.6569C30.5384 14.0474 30.5384 14.6805 30.9289 15.0711C31.3195 15.4616 31.9526 15.4616 32.3431 15.0711L38.7071 8.70711ZM0 9H38V7H0V9Z"
        fill="#BFBFBF"
      />
    </svg>
  );
}
